// extracted by mini-css-extract-plugin
export default {"container":"TeamsCellRenderer_container__XmuJG","tag":"TeamsCellRenderer_tag__Uib3c"};